import React, { useState, useEffect } from "react";
import "../styles/Navbar.css";
import logo from "../assets/images/Empower.svg";
import webDevIcon from "../assets/clients/f1.webp";
import webDesignIcon from "../assets/clients/f2.webp";
import seoIcon from "../assets/clients/f3.webp";
import digitalIcon from "../assets/clients/f4.webp";
import contentIcon from "../assets/clients/f1.webp";
import aiIcon from "../assets/clients/f2.webp";
// import {
//   FaGlobe,
//   FaSearch,
//   FaPen,
//   FaPalette,
//   FaFire,
//   FaRobot,
//   FaCog,
//   FaChartLine,
//   FaBullseye,
//   FaSync,
//   FaFolder,
//   FaClipboardList,
//   FaStar,
//   FaBook,
//   FaComments,
// } from "react-icons/fa";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [mobileDropdownOpen, setMobileDropdownOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuOpen && !e.target.closest(".navbar")) {
        setMenuOpen(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, [menuOpen]);
  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [menuOpen]);

  const toggleMobileDropdown = () => {
    setMobileDropdownOpen(!mobileDropdownOpen);
  };

  return (
    <>
      <header className={`navbar ${scrolled ? "scrolled" : ""}`}>
        <div className="logo">
          <img src={logo} alt="Logo" width="150" height="40" />
        </div>

        <nav className={menuOpen ? "nav-links active" : "nav-links"}>
          <a href="./" className="nav-item active">
            Home
          </a>
          <a href="./About" className="nav-item">
            About
          </a>

          {/* <div
            className="dropdown"
            onMouseEnter={() => setDropdownOpen(true)}
            onMouseLeave={() => setDropdownOpen(false)}
          >
            <a
              href="#solutions"
              className="nav-item drop-toggle"
              onClick={(e) => {
                if (window.innerWidth <= 992) {
                  e.preventDefault();
                  toggleMobileDropdown();
                }
              }}
            >
              Our Services
              <span
                className={`arrow ${mobileDropdownOpen ? "open" : ""}`}
              ></span>
            </a>
            <div
              className={`dropdown-menu ${dropdownOpen || mobileDropdownOpen ? "show" : ""}`}
            >
              <div className="dropdown-column">
                <h4 className="dropdown-column-title">Web Development</h4>
                <a href="./Webdevelopment" className="dropdown-item">
                  <FaGlobe className="icon" />
                  <span>Web Development</span>
                </a>
                <a href="/ui-ux-design-noida" className="dropdown-item">
                  <FaPalette className="icon" />
                  <span>Static Website Development</span>
                </a>
                <a href="/ui-ux-design-noida" className="dropdown-item">
                  <FaPalette className="icon" />
                  <span>Dynamic Website Development</span>
                </a>
                <a href="/ui-ux-design-noida" className="dropdown-item">
                  <FaPalette className="icon" />
                  <span>Custom Website Development</span>
                </a>
                <a href="/ui-ux-design-noida" className="dropdown-item">
                  <FaPalette className="icon" />
                  <span>WordPress Development</span>
                </a>
                <a href="/ui-ux-design-noida" className="dropdown-item">
                  <FaPalette className="icon" />
                  <span>E-Commerce Website Development</span>
                </a>
                <a href="/ui-ux-design-noida" className="dropdown-item">
                  <FaPalette className="icon" />
                  <span>API Integration</span>
                </a>
                <a href="/ui-ux-design-noida" className="dropdown-item">
                  <FaPalette className="icon" />
                  <span>Website Speed Optimization</span>
                </a>
              </div>



              <div className="dropdown-column">
                <h4 className="dropdown-column-title">Digital Marketing</h4>
                <a href="./Seo" className="dropdown-item">
                  <FaSearch className="icon" />
                  <span>Google Ads (PPC Advertising)</span>
                </a>
                <a href="/content-writing-services" className="dropdown-item">
                  <FaPen className="icon" />
                  <span>Facebook & Instagram Ads</span>
                </a>
                <a
                  href="/ai-driven-digital-marketing"
                  className="dropdown-item"
                >
                  <FaRobot className="icon" />
                  <span>Social Media Marketing</span>
                </a>
                <a
                  href="/ai-driven-digital-marketing"
                  className="dropdown-item"
                >
                  <FaRobot className="icon" />
                  <span>Email Marketing Automation</span>
                </a>
              </div>
 
              <div className="dropdown-column">
                <h4 className="dropdown-column-title">Web Design</h4>
                <a href="./Seo" className="dropdown-item">
                  <FaSearch className="icon" />
                  <span>UI/UX Design</span>
                </a>
                <a href="/content-writing-services" className="dropdown-item">
                  <FaPen className="icon" />
                  <span>Website Layout Design</span>
                </a>
                <a
                  href="/ai-driven-digital-marketing"
                  className="dropdown-item"
                >
                  <FaRobot className="icon" />
                  <span>Responsive Website Design</span>
                </a>
                <a
                  href="/ai-driven-digital-marketing"
                  className="dropdown-item"
                >
                  <FaRobot className="icon" />
                  <span>Landing Page Design</span>
                </a>
                <a
                  href="/ai-driven-digital-marketing"
                  className="dropdown-item"
                >
                  <FaRobot className="icon" />
                  <span>E-Commerce Store Design</span>
                </a>
                <a
                  href="/ai-driven-digital-marketing"
                  className="dropdown-item"
                >
                  <FaRobot className="icon" />
                  <span>Dashboard / Admin Panel Design</span>
                </a>
                <a
                  href="/ai-driven-digital-marketing"
                  className="dropdown-item"
                >
                  <FaRobot className="icon" />
                  <span>Logo & Branding Design</span>
                </a>
                <a
                  href="/ai-driven-digital-marketing"
                  className="dropdown-item"
                >
                  <FaRobot className="icon" />
                  <span>Banner & Graphics Design</span>
                </a>
              </div>

              <div className="dropdown-column">
                <h4 className="dropdown-column-title">Growth Strategies</h4>
                <a href="/increase-sales-strategy" className="dropdown-item">
                  <FaChartLine className="icon" />
                  <span>Sales Growth Strategy</span>
                </a>
                <a href="/lead-generation-services" className="dropdown-item">
                  <FaBullseye className="icon" />
                  <span>Lead Generation</span>
                </a>
                <a href="/sales-funnel-optimization" className="dropdown-item">
                  <FaSync className="icon" />
                  <span>Sales Funnel Optimization</span>
                </a>
              </div>
              <div className="dropdown-column">
                <h4 className="dropdown-column-title">Business Services</h4>
                <a href="/branding-services-noida" className="dropdown-item">
                  <FaFire className="icon" />
                  <span>Branding Services</span>
                </a>
                <a
                  href="/business-development-automation"
                  className="dropdown-item"
                >
                  <FaCog className="icon" />
                  <span>Business Automation</span>
                </a>
              </div>

              <div className="dropdown-column">
                <h4 className="dropdown-column-title">Resources</h4>
                <a href="/portfolio" className="dropdown-item">
                  <FaFolder className="icon" />
                  <span>Portfolio</span>
                </a>
                <a href="/case-studies" className="dropdown-item">
                  <FaClipboardList className="icon" />
                  <span>Case Studies</span>
                </a>
                <a href="/testimonials" className="dropdown-item">
                  <FaStar className="icon" />
                  <span>Testimonials</span>
                </a>
                <a href="/resources" className="dropdown-item">
                  <FaBook className="icon" />
                  <span>Resources</span>
                </a>
                <a href="/free-consultation" className="dropdown-item">
                  <FaComments className="icon" />
                  <span>Free Consultation</span>
                </a>
              </div>
            </div>
          </div> */}

          <div
            className="dropdown"
            onMouseEnter={() => setDropdownOpen(true)}
            onMouseLeave={() => setDropdownOpen(false)}
          >
            {/* <a href="/" className="nav-item drop-toggle">
              Our Services
            </a> */}
            <a
              href="/"
              className="nav-item drop-toggle"
              onClick={(e) => {
                if (window.innerWidth <= 992) {
                  e.preventDefault();
                  toggleMobileDropdown();
                }
              }}
            >
              Our Services
            </a>

            <div className={`dropdown-menu ${dropdownOpen ? "show" : ""}`}>
              {/* Web Development */}
              <a href="/web-development-company-in-noida" className="dropdown-item">
                <img
                  src={webDevIcon}
                  alt="Web Development"
                  className="icon-img"
                />
                <span>Web Development</span>
              </a>
              {/* Web Design */}
              <a href="/web-design-services" className="dropdown-item">
                <img
                  src={webDesignIcon}
                  alt="Web Design"
                  className="icon-img"
                />
                <span>Web Design</span>
              </a>
              {/* SEO Services */}
              <a href="/seo-agency-noida" className="dropdown-item">
                <img src={seoIcon} alt="SEO Services" className="icon-img" />
                <span>SEO Services</span>
              </a>
             
              {/* Content Marketing */}
              <a href="/content-marketing-services" className="dropdown-item">
                <img
                  src={contentIcon}
                  alt="Content Marketing"
                  className="icon-img"
                />
                <span>Content Marketing</span>
              </a>
               {/* socia media marketing */}
              <a href="/social-media-marketing-services" className="dropdown-item">
                <img
                  src={contentIcon}
                  alt="social-media-marketing"
                  className="icon-img"
                />
                <span>Social Media Marketing</span>
              </a>
              {/* AI Automation Services */}
              <a href="/ai-automation-services" className="dropdown-item">
                <img
                  src={aiIcon}
                  alt="AI Automation Services"
                  className="icon-img"
                />
                <span>AI Automation Services</span>
              </a>
           
              {/* Lead Generation */}
              <a href="/lead-generation-services" className="dropdown-item">
                <img
                  src={webDesignIcon}
                  alt="Lead Generation"
                  className="icon-img"
                />
                <span>Lead Generation</span>
              </a>
              {/* Sales Funnel Optimization */}
              <a href="/sales-funnel-optimization" className="dropdown-item">
                <img
                  src={seoIcon}
                  alt="Sales Funnel Optimization"
                  className="icon-img"
                />
                <span>Sales Funnel Optimization</span>
              </a>
              {/* Branding Services */}
              <a href="/branding-agency-noida" className="dropdown-item">
                <img
                  src={digitalIcon}
                  alt="Branding Services"
                  className="icon-img"
                />
                <span>Branding Services</span>
              </a>
              {/* Business Automation */}
              <a
                href="/business-automation-services"
                className="dropdown-item"
              >
                <img
                  src={contentIcon}
                  alt="Business Automation"
                  className="icon-img"
                />
                <span>Business Automation</span>
              </a>
              {/* Resources */}
              <a href="/resources" className="dropdown-item">
                <img src={aiIcon} alt="Resources" className="icon-img" />
                <span>Resources</span>
              </a>
            </div>
          </div>
          <a href="./portfolio" className="nav-item">
            Portfolio
          </a>
          <a href="./Blog" className="nav-item">
            Blog
          </a>
          <a href="./Contact" className="nav-item">
            Contact Us
          </a>
          <a href="/Contact" className="request-btn">
            Request a Call
            <span className="arrow">→</span>
          </a>
        </nav>

        <div
          className={`menu-toggle ${menuOpen ? "active" : ""}`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>
      </header>

      {/* Overlay for mobile menu */}
      {menuOpen && (
        <div className="overlay" onClick={() => setMenuOpen(false)}></div>
      )}
    </>
  );
};

export default Navbar;
